import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "p400_cart";

const sameLine = (a, b) =>
  a.product_id === b.product_id && a.size === b.size &&
  JSON.stringify([...a.extras].sort()) === JSON.stringify([...b.extras].sort()) &&
  JSON.stringify([...a.removed].sort()) === JSON.stringify([...b.removed].sort()) &&
  JSON.stringify(a.builder || null) === JSON.stringify(b.builder || null);

export const toOrderItems = (items) => items.map((x) => ({ product_id: x.product_id, size: x.size, quantity: x.quantity, extras: x.extras || [], ...(x.builder ? { builder: x.builder } : { removed: x.removed || [] }) }));

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem(KEY) || "[]"));

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (line) => setItems((prev) => {
    const i = prev.findIndex((x) => sameLine(x, line));
    if (i < 0) return [...prev, { ...line, key: `${Date.now()}-${Math.random()}` }];
    return prev.map((x, j) => (j === i ? { ...x, quantity: x.quantity + line.quantity } : x));
  });
  const setQty = (key, q) => setItems((prev) => (q <= 0 ? prev.filter((x) => x.key !== key) : prev.map((x) => (x.key === key ? { ...x, quantity: q } : x))));
  const clear = () => setItems([]);

  const total = items.reduce((a, x) => a + x.unit_price * x.quantity, 0);
  const count = items.reduce((a, x) => a + x.quantity, 0);
  const teglie = items.reduce((a, x) => a + (x.size === "teglia" ? x.quantity : x.size === "mezza" ? x.quantity * 0.5 : 0), 0);
  const rotonde = items.reduce((a, x) => a + (x.size === "rotonda" ? x.quantity : 0), 0);

  return <CartContext.Provider value={{ items, add, setQty, clear, total, count, teglie, rotonde }}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
